let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("gwMMy"), load("hoLvO"), load("c37CC")]).then(() => parcelRequire('cVptH'));